import { Component, Input, OnInit } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';

@Component({
    selector: 'app-BadgeTableComponent',
    templateUrl: './BadgeTableComponent.component.html',
    styleUrls: ['./BadgeTableComponent.component.css'],
    standalone: false
})
export class BadgeTableComponent extends TableElementComponent {

  @Input() status: string = '';

  protected currentStatus: AvailableBadgeStatus | undefined;

  @Input() availableStatuses: AvailableBadgeStatus[] = [];

  override ngOnInit(): void {
    super.ngOnInit();
    this.availableStatuses = this.props.availableStatuses || [];
    this.status = this.props.status(this.data)
    this.currentStatus = this.getStatusBadge(this.status);  
  }

  getStatusBadge(status: string) {
    const foundStatus = this.availableStatuses.find(s => s.value === status);
    return foundStatus ? foundStatus : undefined;
  }

}

export interface AvailableBadgeStatus {
  value: string;
  label: string;
  color: string;
}
